import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22324318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MModalDeAlerta__Header" }
const _hoisted_2 = { class: "MModalDeAlerta__Conteudo" }

import { computed, WritableComputedRef, withDefaults } from "vue"
  import type { TipoMensagem } from ".."
  import Dialog from "primevue/dialog"

  interface Props {
    cabecalho: string
    modelValue: boolean
    teleportarPara?: string
    dataTestid?: string
    tipo?: TipoMensagem
    fechavel?: boolean
  }
  type EmitirModelo = (event: "update:modelValue", modelValue: boolean) => void
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MModalDeAlerta',
  props: {
    cabecalho: null,
    modelValue: { type: Boolean },
    teleportarPara: { default: "body" },
    dataTestid: null,
    tipo: { default: "padrao" },
    fechavel: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ((event: "update:modelValue", modelValue: boolean) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { cabecalho: string, modelValue: boolean, teleportarPara: string, dataTestid?: string, tipo: TipoMensagem, fechavel: boolean }

  

  

  const alertaEstaVisivel: WritableComputedRef<boolean> = computed({
    get(): boolean {
      return props.modelValue
    },
    set(value: boolean) {
      emitir("update:modelValue", value)
    },
  })

  const dicionarioDeIconesConformeTipo = {
    erro: "pi pi-times-circle",
    atencao: "pi pi-exclamation-triangle",
    padrao: "",
  }

  const dicionarioDeNomeDeClassesConformeTipo = {
    erro: "MModalDeAlerta--erro",
    atencao: "MModalDeAlerta--atencao",
    padrao: "",
  }
  const icone = computed(() => {
    return dicionarioDeIconesConformeTipo[props.tipo]
  })

  const nomeDeClasse = computed(() => {
    return dicionarioDeNomeDeClassesConformeTipo[props.tipo]
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(alertaEstaVisivel),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(alertaEstaVisivel) ? (alertaEstaVisivel).value = $event : null)),
    "append-to": __props.teleportarPara,
    class: _normalizeClass(["MModalDeAlerta", _unref(nomeDeClasse)]),
    closable: __props.fechavel,
    "data-testid": __props.dataTestid,
    "dismissable-mask": "",
    draggable: false,
    modal: "",
    style: { 'min-width': '550px', height: 'auto' }
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(__props.cabecalho), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "acoes")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_unref(icone))
          ? (_openBlock(), _createElementBlock("em", {
              key: 0,
              class: _normalizeClass(_unref(icone)),
              "data-testid": "MModalDeAlerta__Icone"
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _renderSlot(_ctx.$slots, "conteudo")
        ])
      ])
    ]),
    _: 3
  }, 8, ["visible", "append-to", "class", "closable", "data-testid"]))
}
}

})